import React from 'react';
import { ElementVisibility } from './types';
import { useElementVisibilityMap } from './useElementVisibilityMap';
export const ElementVisibilityContext = /*#__PURE__*/ React.createContext({
    elementGroups: {
        adoptableBuyer: undefined,
        adoptableSeller: undefined
    },
    deleteDeviation: ElementVisibility.NotIncluded,
    editBackground: ElementVisibility.NotIncluded,
    editDeviation: ElementVisibility.NotIncluded,
    favourite: ElementVisibility.NotIncluded,
    fullscreen: ElementVisibility.NotIncluded,
    linkNft: ElementVisibility.NotIncluded,
    report: ElementVisibility.NotIncluded,
    share: ElementVisibility.NotIncluded,
    subscribe: ElementVisibility.NotIncluded,
    comment: ElementVisibility.NotIncluded,
    premiumDownload: ElementVisibility.NotIncluded,
    freeDownload: ElementVisibility.NotIncluded,
    addToGroup: ElementVisibility.NotIncluded,
    awardBadge: ElementVisibility.NotIncluded,
    sellDeviation: ElementVisibility.NotIncluded,
    privateCollection: ElementVisibility.NotIncluded
});
export const ElementVisibilityContextProvider = ({ deviation, children })=>{
    const visibilityMap = useElementVisibilityMap(deviation);
    return /*#__PURE__*/ React.createElement(ElementVisibilityContext.Provider, {
        value: visibilityMap
    }, children);
};
ElementVisibilityContextProvider.displayName = 'ElementVisibilityContextProvider';
